export type ExportDateRangeParams = {
  date_from: string;
  date_to: string;
};

export type ExportInvoiceParams = {
  invoice_id: number;
  invoice_label?: string;
};

export type ExportNoParams = Record<string, never>;

export type ExportStartParams = ExportDateRangeParams | ExportInvoiceParams | ExportNoParams;

export function isExportDateRangeParams(params: ExportStartParams): params is ExportDateRangeParams {
  return 'date_from' in params;
}

export type ExportQueuedResponse = {
  export_id: string;
  status: 'queued';
};

export type ExportStatus = 'queued' | 'processing' | 'completed' | 'failed';

export type ExportStatusResponse = {
  export_id: string;
  status: ExportStatus;
  url_file: string | null;
  error: string | null;
};
